import React, { useState, useEffect,useRef } from "react";
import "./Sidebar.css";
import { useNavigate } from "react-router-dom";
import logout from "../../assets/images/logoutIcon.png";
import logoutConfirm from "../../assets/images/logout.png";
import minMaxIcon from "../../assets/images/menu.png";
import { toast } from "react-toastify";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import Tooltip from '../Title/Title';
import sidebarIcon1 from '../../assets/images/Black.svg';
import sidebarIcon2 from '../../assets/images/Black-1.svg';
import sidebarIcon3 from '../../assets/images/Black-2.svg';
import sidebarIcon4 from '../../assets/images/Black.svg';

function Sidebar({ onToggleMinimize }) {
  
  const [isMinimized, setIsMinimized] = useState(() => {
    const saved = localStorage.getItem("sidebarMinimized");
    return saved=='true';
    });
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("sidebarMinimized", isMinimized);
  }, [isMinimized]);

  const toggleSidebar = () => {
    const newState = !isMinimized;
    setIsMinimized(newState);
    onToggleMinimize(newState);
  };

  const handleLogout = () => {
    toast.success("Logout successful!");
    localStorage.clear();
    setShowModal(false);
    navigate('/sign-in'); 
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <div className={`sidebar ${isMinimized ? "minimized" : ""}`}>
        {/* <div className="logo">
          <div className="sidebar-title">
          <button onClick={toggleSidebar} className="toggle-button">
            {<img height="20px" width="20px" src={minMaxIcon} alt="" />}
          </button>
            {!isMinimized && (
              <span style={{marginLeft:'15%'}}>
                <span>Enterprise</span>
                <span className="sidebar-sub-title">GPT</span>
              </span>
            )}
          </div>
        </div> */}

        <div className="navigation">
          {!isMinimized && <ThreadManager></ThreadManager>}
         <div onClick={handleOpenModal} style={{cursor: "pointer"}}  className={`nav-item-logout ${isMinimized ? "minimized" : ""}`}>
          {/* {!isMinimized && <p className="profile-name">Log Out</p>} */}
          {/* <span>
            <img style={{ position:'relative',top:'2px' }} src={logout} alt="Logout" />
            </span> */}
        </div>
        </div>
      </div>
      
      <LogoutModal 
        show={showModal} 
        handleLogout={handleLogout} 
        handleClose={handleCloseModal} 
      />

    </div>
  );
}

export default Sidebar;
const LogoutModal = ({ show, handleLogout, handleClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={logoutConfirm} alt="Logout Icon" />
        </div>
        <div className="logout-text">Are you sure you want to LogOut?</div>
        <div className="modal-buttons">
          <button onClick={handleLogout} className="yes-btn">Yes</button>
          <button onClick={handleClose} className="no-btn">No</button>
        </div>
      </div>
    </div>
  );
};

const ThreadManager = () => {
  const [threads, setThreads] = useState([
    {
      id: 1,
      title: "NDA India",
      items: [
        "Best Practices for Sustainable",
        "Improve Precision agriculture",
        "Organic vs chemical fertilizers",
        "Difference between UPL",
      ],
    }
  ]);

  const [newThreadTitle, setNewThreadTitle] = useState("");
  const savedThreadId = localStorage.getItem("selectedThreadId");
  const savedItemIndex = localStorage.getItem("selectedItemIndex");
  const [selectedThreadId, setSelectedThreadId] = useState(
    Number(savedThreadId)
  );
  const [selectedItemIndex, setSelectedItemIndex] = useState(
    Number(savedItemIndex)
  );
  const [showModalMore, setShowModalMore] = useState(false);
  const [editTitle, setEditTitle] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const { emit } = useEventEmitter();
  const [openedModelIndex, setOpenedModelIndex] = useState(null);
  const [openedThreadId, setOpenedThreadId] = useState(null);
  const modalRef = useRef(null);
  const [showAddThreadModal, setShowAddThreadModal] = useState(false);
  const inputRefAdd = useRef(null);
  const [addNewThreadID, setAddNewThreadID] = useState('');
  const [hoveredThreadId, setHoveredThreadId] = useState(null);
  const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
  const sidebarIcons = [sidebarIcon1, sidebarIcon2, sidebarIcon3, sidebarIcon4];

  const handleThreadClick = (threadId, index, threadTitle, threadItem) => {
    emit("thread", { threadTitle, threadItem });
    setSelectedThreadId(threadId);
    setSelectedItemIndex(index);
    localStorage.setItem("selectedThreadId", threadId);
    localStorage.setItem("selectedItemIndex", index.toString());
  };

  const openModal = (e, threadId, itemIndex, currentTitle) => {
    const rect = e.target.getBoundingClientRect();
    setOpenedThreadId(threadId);
    setOpenedModelIndex(itemIndex);
    setEditTitle(currentTitle);
    setShowModalMore(true);
    setModalPosition({
      top: rect.bottom + window.scrollY + 5,
      left: rect.left + window.scrollX - 10,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModalMore(false);
        setOpenedThreadId(null);
        setOpenedModelIndex(null);
        setIsEditing(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isEditing && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isEditing]);

  //*************Main Thread Important**************
  // const handleAddThread = () => {
  //   if (newThreadTitle.trim() !== "") {
  //     const newThread = {
  //       id: Date.now(),
  //       title: newThreadTitle,
  //       items: [],
  //     };
  //     setThreads([...threads, newThread]);
  //     setNewThreadTitle(""); // Clear input after adding thread
  //     setShowAddThreadModal(false); // Close the modal after adding
  //   }
  // };

  const handleAddThread = () => {
    if (newThreadTitle.trim() !== "") {
      const updatedThreads = threads.map((thread) => {
        if (thread.id === addNewThreadID) {
          return {
            ...thread,
            items: [...thread.items, newThreadTitle],
          };
        }
        return thread;
      });

      setThreads(updatedThreads);
      setNewThreadTitle("");
      setShowAddThreadModal(false);
    }
  };

  const openAddThreadModal = (e, threadId) => {
    const rect = e.target.getBoundingClientRect();
    setAddNewThreadID(threadId);
    setModalPosition({
      top: rect.bottom + window.scrollY + 5,
      left: rect.left + window.scrollX - 10,
    });
    setShowAddThreadModal(true);
  };

  const closeAddThreadModal = () => {
    setShowAddThreadModal(false);
    setNewThreadTitle('');
  };

  // Handle renaming an item in a thread
  const handleRenameItem = () => {
    if (editTitle.trim() === "") {
      alert("Title cannot be empty.");
      return;
    }
    const updatedThreads = threads.map((thread) =>
      thread.id === openedThreadId
        ? {
            ...thread,
            items: thread.items.map((item, index) =>
              index === openedModelIndex ? editTitle : item
            ),
          }
        : thread
    );
    setThreads(updatedThreads);
    setEditTitle("");
    setIsEditing(false);
    setShowModalMore(false);
    setOpenedThreadId(null);
    setOpenedModelIndex(null);
  };

  // Handle removing an item from a thread
  const handleRemoveItem = () => {
    if (openedThreadId !== null && openedModelIndex !== null) {
      const updatedThreads = threads.map((thread) => {
        if (thread.id === openedThreadId) {
          return {
            ...thread,
            items: thread.items.filter(
              (_, index) => index !== openedModelIndex
            ),
          };
        }
        return thread;
      });
      setThreads(updatedThreads);
      setShowModalMore(false);
      setOpenedThreadId(null);
      setOpenedModelIndex(null);
      setIsEditing(false);
    } else {
      console.error("Opened thread or item index is not set.");
    }
  };

  const handleMouseEnter = (threadId, index) => {
    setHoveredThreadId(threadId);
    setHoveredItemIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredThreadId(null);
    setHoveredItemIndex(null);
  };

  const inProgress = ()=>{
    toast.warn("This feature work in progress!");
  }

  return (
    <div className="container">
      <div>
        {threads.map((thread, index) => 
        (
          <div key={index}>
            <div className="add-thread">
             
            <Tooltip text="This is a custom tooltip!"> 
              <div className="add-new-button-container">
                <button
              // title="New Chat"
                // onClick={(e) => openAddThreadModal(e, thread.id)}
                className="add-thread-button"
              >
                + New Chat
              </button>
                </div>
              </Tooltip>
            </div>
            <div key={thread.id} className="thread-card">
              <div className="threadItems">
                {thread.items.map((item, index) => (
               <Tooltip text="This is a custom tooltip!" key={index}> 
                <span
                    
                    className={selectedThreadId === thread.id &&
                      selectedItemIndex === index?"thread-item-text":"thread-item"}
                    // onClick={(e) => {
                    //   handleThreadClick(thread.id, index, thread.title, item);
                    // }}
                    onMouseEnter={() => handleMouseEnter(thread.id, index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div
                      className="thread-item"
                    >
                      {isEditing &&
                      openedThreadId === thread.id &&
                      openedModelIndex === index ? (
                        <input
                        ref={modalRef}
                        type="text"
                        value={editTitle}
                        onChange={(e) => setEditTitle(e.target.value)}
                        className="renameInput"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleRenameItem();
                          } else if (e.key === "Escape") {
                            setIsEditing(false);
                          }
                        }}
                        autoFocus
                      />
                      ) : (
                        
                        <span 
                        className={selectedThreadId === thread.id &&
                        selectedItemIndex === index?"thread-item-text":"thread-item"}>
                          {/* <span> */}
                          <img src={sidebarIcons[index % sidebarIcons.length]} alt="icon" />
                            <span className="thread-item-span">
                          {item} 
                          </span>
                            {/* </span> */}
                        </span>
                          
                      )}
                      {(hoveredThreadId === thread.id &&
                        hoveredItemIndex === index) ||
                      (openedThreadId === thread.id &&
                        openedModelIndex === index &&
                        showModalMore) ? (
                        <button
                          className="moreButton"
                        >
                          ⋮
                        </button>
                      ) : null}
                    </div>
                  </span>
                  </Tooltip>
                ))}
              </div>
              {showModalMore && openedThreadId === thread.id && (
                <div
                  ref={modalRef}
                  style={{
                    ...styles.modal,
                    top: modalPosition.top,
                    left: modalPosition.left,
                    display: "block",
                  }}
                >
                  <div className="modalArrow"></div>
                  <div className="modalContent">
                    <button
                      onClick={() => {
                        setIsEditing(true);
                        setShowModalMore(false);
                      }}
                      className="modalButtonPrimary"
                    >
                      Rename thread
                    </button>
                    <button
                      onClick={handleRemoveItem}
                      className="modalButtonSecondary"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {showAddThreadModal && (
        <div
          style={{
            ...styles.modal,
            top: modalPosition.top,
            left: modalPosition.left,
            display: "block",
          }}
        >
          <div className="modalArrow"></div>
          <div className="modalContent">
            <input
              ref={inputRefAdd}
              type="text"
              placeholder="New thread title"
              value={newThreadTitle}
              onChange={(e) => setNewThreadTitle(e.target.value)}
              className="addThreadInput"
              autoFocus
            />
            <div className="modalActions">
              <button
                onClick={closeAddThreadModal}
                className="modalButtonSecondary"
              >
                Cancel
              </button>
              <button onClick={handleAddThread} className="modalButtonPrimary">
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  threadItems: {
    marginTop: "10px",
  },
  threadItem: {
    fontSize: "15px",
    color: "#666",
    height: "20px",
  },
  modal: {
    position: "absolute",
    backgroundColor: "#fff",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    zIndex: 100,
    display: "none",
    textAlign: "center",
    border: "1px solid #ddd",
    minWidth: "14%",
  },
};